/**
 * Sales (marketplace) order charge lines — used when summary is not a job order (installation/removal).
 */

export function getSalesOrderChargesFirstRow(publicOrder: any): any | null {
  return Array.isArray(publicOrder?.order_charges) ? publicOrder.order_charges[0] : null;
}

export function computeSalesShippingCharges(salesOrderCharges: any | null): number {
  return Number(
    salesOrderCharges?.shipping_option?.reduce(
      (sum: number, row: any) => sum + Number(row?.shipping_amount || 0),
      0
    ) || 0
  );
}

export function computeSalesSpecialFeeCharges(salesOrderCharges: any | null): number {
  return Number(
    salesOrderCharges?.specialfee?.reduce(
      (sum: number, row: any) => sum + Number(row?.specialfee_amount || 0),
      0
    ) || 0
  );
}
